import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IPersonBody } from '../person-body-schema';
import type { IPersonResponse } from '../person-response';
import { personResponseSchema } from '../person-response';

export async function updatePersonApi(
  id: number,
  body: Partial<IPersonBody>,
): Promise<IValidatedResponse<IPersonResponse>> {
  return putRequest<IPersonResponse>({
    path: `/sys/people/v1/${id}`,
    body,
    schema: personResponseSchema,
  });
}
